import React from "react";
import { useNavigate } from "react-router-dom";
import HomeNav from "../components/landingPage/HomeNav";
import HomeFooter from "../components/landingPage/HomeFooter";
import ContactForm from "../components/ContactForm";
import secureLocalStorage from "react-secure-storage";

const ContactUs = () => {
  const navigate = useNavigate();
  /**
   * if user is already logged in then redirect to dashboard,
   * instead of returning the login page
   */
  if (secureLocalStorage.getItem("token")) {
    navigate("/dashboard");
  }

  return (
    <div>
      <HomeNav />

      <div className="w-full flex flex-col py-12 justify-between items-center bg-[#FAF8F7]">
          <h5 className="text-xl font-semibold">Welcome to TwoKey Support</h5>
          <h1 className="text-6xl my-4">How can we help you today?</h1>
      </div>

      <ContactForm />
      <HomeFooter />
    </div>
  );
};

export default ContactUs;
